$(function() {
  $(document).ready(function() {
    $('select').not('.browser-default').formSelect()

    // this is a hack to make select show interactions similar to input
    $('input.dropdown-trigger').on('click', function(e) {
      $wrapper = $(e.target).closest('div.select-wrapper')
      $wrapper.next().addClass('active')
    })

    $('select').on('change', function(e) {
      $select = $(e.target)
      $div = $select.parent()
      $label = $div.next()

      if($select.val().length > 0) {
        $label.addClass('active')
      }
      else {
        $label.removeClass('active')
      }
    })

    for (let div of Array.from($('div.select-wrapper'))) {
      $(div).children('select').trigger('change');
    }
  })
})

// Menú hamburguesa de la barra de navegación (mobile)
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('sindmaMenuToggle')
  const menu = document.getElementById('sindmaNavMenu')

  if (!toggle || !menu) return

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('open')
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
  })
})
